import { deleteBeneficiary, deleteUser, searchQuery, updateSubsciberHttp } from "../../Http/Index"

export const deleteUserData = async (payload: any) => {
    try {
        await deleteUser(payload)
        // console.log(data)
        alert("User Deleted Successfully")
    }
    catch (error: any) {
        console.log(error)
        alert(error.response?.data?.message)
    }
    return true
}

export const deleteBeneficiaryData = async (beneficiaryId: string) => {
    try {
        await deleteBeneficiary(beneficiaryId)
        alert("Beneficiary Deleted Successfully")
    }
    catch (error: any) {
        console.log(error)
        alert(error.response?.data?.message)
    }
    return true
}


export const searchQueryFun = async (payload: any) => {
    try {
        let response = await searchQuery(payload)
        // console.log(response)
        return response.data
    } catch (error) {
        console.log(error)
        alert(error)
    }
}

export const updateSubscriber=async(id:string,payload:any)=>{
    try {
        let response = await updateSubsciberHttp(id,payload)
        return response.data
    } catch (error) {
        console.log(error)
        alert(error)
    }

}